import { defineStore } from 'pinia';

export const useNotificationBarStore = defineStore('notificationbar', {
  state: () => ({
    content: '',
    color: '',
    tick: true,
    actionHeaderActive: false
  }),
  actions: {
    showMessage(payload) {
      this.content = payload.content;
      this.color = payload.color;
      this.tick = !this.tick; // force event trigger
    },
    setActionHeaderActive(payload) {
      this.actionHeaderActive = payload;
    }
  }
});
